import { writable } from 'svelte/store';

import url from '@/utils/url';

const uuid = url.get('outcast_uuid') || window.adv?.getAdvUUID?.() || '';

export const visible = writable(true);
export const isLogin = writable(false);
export const isJumpOneLink = writable(false);
export const isCookiesShow = writable(false);
export const cookieHeight = writable(0);
export const omegaParams = writable<Record<string, unknown>>({});
export const startTime = writable(Date.now());
export const userID = writable('');
export const phoneCell = writable('');
export const bottomButtonHeight = writable(0);

export default {
    visible,
    isLogin,
    omegaParams
};
